import { InnerBodyType } from "components/multisplitOptions/types";
import { LabelType } from "components/types";
import { MetaData } from "features/gallery/types";
/* eslint-disable */

export interface ProductReelState {
  reelProducts: Product[];
  highlightedProductsType: ProductReelType;
  isLoading: boolean;
}

export interface Product extends MetaData {
  [key: string]: any;
  alias: string;
  _id: string;
  title: string;
  category: string;
  type: string;
  brand: string;
  model: string;
  class: string;
  quadrature: string;
  power_btu: string;
  energy_class_cooling: string;
  energy_class_heating: string;
  price: number;
  price_eur: number;
  internal_bodies?: InnerBodyType[];
  price_promotion?: number;
  price_promotion_eur?: number;
  favourite: boolean;
  newest: boolean;
  advantageous: boolean;
  best_seller: boolean;
  date_added: string;
  last_update: string;
  description: ProductDescription;
  tech_specs: ProductTechSpecs;
  tags: ProductTag[];
  extras: Extra[];
  images: any;
  objectType: string;
  quantity: number;
}

export interface ProductTag {
  id: string;
  color: string;
  textColor: string;
  title: string;
  type: LabelType;
}

export interface Extra {
  title: string;
  text: string;
  image: Partial<ProductImage>;
}

export interface ProductImage {
  _id: number;
  file_name: string;
  is_main_image: boolean;
  contentType: string;
  image: string;
  alt?: string;
}

export interface ProductDescription {
  text?: string;
  energy_class_cooling: string;
  energy_class_heating: string;
  quadrature: string;
  type: string;
  free_mounting: boolean;
  outbound_power_cooling: string;
  outbound_power_heating: string;
  en_consumption_cooling: string;
  en_consumption_heating: string;
}

export interface ProductTechSpecs {
  data: {
    [key: string]: any;
    common_specs: ProductCommonSpecs;
    internal_specs: ProductInternalExternalSpecs;
    external_specs: ProductInternalExternalSpecs;
  };
  title: string;
}

export interface ProductCommonSpecs {
  data: {
    [key: string]: any;
    quadrature: SpecType;
    energy_class_cooling: SpecType;
    energy_class_heating: SpecType;
    power_btu: SpecType;
    outbound_power_cooling: SpecType;
    outbound_power_heating: SpecType;
    en_consumption_cooling: SpecType;
    en_consumption_heating: SpecType;
    cubature: SpecType;
    eer: SpecType;
    seer: SpecType;
    cop: SpecType;
    scop: SpecType;
    power_supply_voltage: SpecType;
    work_amplitude_cooling: SpecType;
    work_amplitude_heating: SpecType;
    fridge_agent: SpecType;
    pipe_diameter: SpecType;
    power_supply: SpecType;
    country_of_origin: SpecType;
    waranty: SpecType;
    type: SpecType;
    annual_power_consump_cooling: SpecType;
    annual_power_consump_heating: SpecType;
    apf: SpecType;
    heating_power_low_temp: SpecType;
  };
  title: string;
}

export interface ProductInternalExternalSpecs {
  data: {
    [key: string]: any;
    noise: string;
    dimensions: string;
    weight: string;
  };
  title: string;
}

export enum ProductReelType {
  Favourite = "favourite",
  Newest = "newest",
  Advantageous = "advantageous",
  BestSeller = "best_seller",
}

export interface SpecType {
  title: string;
  value: string;
}
